import React from 'react';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import {
  InputTextWithValidationMessage,
  FormikCheckbox,
  FormikRadio,
} from '../../../components/prime-formik';

const i18n = defineMessages({
  enableSuperlink: {
    id: 'enable_super_link',
    defaultMessage: 'Enable Superlink',
  },
  manualActivation: {
    id: 'super_link.activation_type_manual',
    defaultMessage: 'Manual',
  },
  automaticActivation: {
    id: 'super_link.activation_type_automatic',
    defaultMessage: 'Automatic',
  },
  numberOfAssessmentsToDisableAfter: {
    id: 'super_link.number_of_assessments_to_disable_after',
    defaultMessage: 'Disable after assessments',
  },
});

const SuperLinkActivationOptionsForm = ({ setFieldValue, activationType }) => {
  const { formatMessage } = useIntl();

  const enableSuperlink = formatMessage(i18n.enableSuperlink);
  const numberOfAssessmentsToDisableAfter = formatMessage(i18n.numberOfAssessmentsToDisableAfter);

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <FormattedMessage id="super_link.activation_options" defaultMessage="Activation Options">
          {text => (
            <div className="activation-options-header">
              {text}
            </div>
          )}
        </FormattedMessage>
        <div className="p-grid">
          <div className="p-col-4">
            <div className="activation-type-field">
              <Field
                id="super_link_activation_type_manual"
                name="activationType"
                component={FormikRadio}
                labeTextId="super_link.activation_type_manual"
                labelDefaultText={formatMessage(i18n.manualActivation)}
                value="MANUAL"
                inputValue="MANUAL"
                setFieldValue={setFieldValue}
              />
            </div>
            <div className="activation-type-field">
              <Field
                id="super_link_activation_type_manual"
                name="activationType"
                component={FormikRadio}
                labeTextId="super_link.activation_type_automatic"
                labelDefaultText={formatMessage(i18n.automaticActivation)}
                value="AUTOMATIC"
                inputValue="AUTOMATIC"
                setFieldValue={setFieldValue}
              />
            </div>
          </div>
          <div className="p-col-4">
            <div className="activation-options-field">
              <Field
                id="enabled"
                name="enabled"
                component={FormikCheckbox}
                labeTextId="enable_super_link"
                labelDefaultText="Enable SuperLink"
                labelText={enableSuperlink}
                setFieldValue={setFieldValue}
                disabled={activationType === 'AUTOMATIC'}
              />
            </div>
            <div className="activation-options-field">
              <Field
                id="numberOfAssessmentsToDisableAfter"
                name="numberOfAssessmentsToDisableAfter"
                type="number"
                min="0"
                labelText={numberOfAssessmentsToDisableAfter}
                disabled={activationType === 'MANUAL'}
                component={InputTextWithValidationMessage}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SuperLinkActivationOptionsForm.propTypes = {
  setFieldValue: PropTypes.func.isRequired,
  activationType: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default SuperLinkActivationOptionsForm;
